import { collection, doc } from "firebase/firestore";
import { db } from "../firebaseConfig";

/** Normaliza segmentos para evitar undefined/null */
const seg = (v) => (v == null ? "" : String(v)).trim();

/** ===== USERS ===== */
export const userDoc = (uid) => doc(db, "users", seg(uid));
export const userSessionsCol = (uid) => collection(db, "users", seg(uid), "sessions");
export const userOrgsCol = (uid) => collection(db, "users", seg(uid), "orgs");
export const userOrgDoc = (uid, orgId) => doc(db, "users", seg(uid), "orgs", seg(orgId));

/** ===== ORGS (TENANT) ===== */
export const orgDoc = (orgId) => doc(db, "orgs", seg(orgId));
export const orgMembersCol = (orgId) => collection(db, "orgs", seg(orgId), "members");
export const orgMemberDoc = (orgId, uid) => doc(db, "orgs", seg(orgId), "members", seg(uid));
export const orgInvitesCol = (orgId) => collection(db, "orgs", seg(orgId), "invitations");
export const orgInviteDoc = (orgId, inviteId) => doc(db, "orgs", seg(orgId), "invitations", seg(inviteId));

/** Colección ERP dentro de un org: ej. orgCollection(orgId, "cotizaciones") */
export const orgCollection = (orgId, colName) =>
  collection(db, "orgs", seg(orgId), seg(colName));

/** Documento ERP dentro de un org: ej. orgDocIn(orgId,"cotizaciones",cotId) */
export const orgDocIn = (orgId, colName, docId) =>
  doc(db, "orgs", seg(orgId), seg(colName), seg(docId));

/** Subcolección dentro de un doc ERP:
 * ej. orgSubcollection(orgId,"cotizaciones",cotId,"items")
 */
export const orgSubcollection = (orgId, colName, docId, subcol) =>
  collection(db, "orgs", seg(orgId), seg(colName), seg(docId), seg(subcol));
